// extracted by mini-css-extract-plugin
export var container = "styles-module__container___IBJCE";
export var withPhotos = "styles-module__withPhotos___p5l8y";
export var photoItem = "styles-module__photoItem___JxkTK";
export var placeholder = "styles-module__placeholder___Q2PHG";
export var addPhotosBtn = "styles-module__addPhotosBtn___LcFw3";
export var photoButton = "styles-module__photoButton___mpQlh";
export var photo = "styles-module__photo____m7QY";
export var spacer = "styles-module__spacer___SSZUR";